import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";

const sortBrandsAndFormatBrands = (brands: string[]): DropdownItemProps[] =>
  brands.sort((a, b) => a.localeCompare(b)).map((brand, idx) => ({ key: idx, value: idx, text: brand }));

export const useTyreBrandsQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({
    queryKey: selectedLocation?.is_tyre_team_enabled ? TyreDiscountsDashboardQueryKeys.tyreTeamBrands : TyreDiscountsDashboardQueryKeys.tyreBrands,
    queryFn: async ({ endpoint, baseUrl }) => {
      if (selectedLocation?.is_tyre_team_enabled) return (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation.id }, baseUrl)).data.brands;
      return (await ApiInstance.get(endpoint, baseUrl)).data.brands;
    },
    select: sortBrandsAndFormatBrands,
    enabled: Boolean(selectedLocation?.id)
  });
};
